import { sendEmailVerification, User } from "firebase/auth";
import { useUser } from "../../utils/AuthContext";
import Button from "./Button";

const EmailVerificationCta = () => {
  const { user } = useUser();

  const handleSendVerificationEmail = async () => {
    await sendEmailVerification(user as User);

    alert(
      "Verification email sent. You may need to look into your spam folder."
    );
  };

  return (
    <>
      <div className="w-full mb-4 md:w-3/4 p-4 mt-4 flex flex-col gap-4 rounded-xl bg-white border">
        <p className="font-bold">
          In order to use AI Excel Bot, users are required to verify email.
        </p>
        <p>
          We have sent you a verification email at{" "}
          <span className="font-bold">{user?.email}</span>. Click the link in
          the email to verify your account and get access to AI Excel Bot. You
          may need to look into your spam folder.
        </p>

        <p>
          Looking forward to see you use AI Excel Bot to it&apos;s full
          potential!
        </p>
      </div>
      <Button variant="Large" onClick={handleSendVerificationEmail}>
        Resend Verification Email
      </Button>
    </>
  );
};

export default EmailVerificationCta;
